import fetchWrapper from "../utils/fetch/fetchWrapper";
const fetchGasolineVehicles = async params => {
    // Remove null params
    Object.keys(params).forEach(key => params[key] == null && delete params[key]);
  
    let url = new URL(
      `${process.env.REACT_APP_API_HOST}/vehicles`
    );
  
    let searchParams = new URLSearchParams(params);
  
    url.search = searchParams;
  
   const json = await fetchWrapper(url, {
     method: 'GET',
   });

   if (!json || !json.vehicles) {
     console.error('Invalid API response for gasoline vehicles:', json);
     return [];
   }

    const gasolineVehicles = json.vehicles;

    if (gasolineVehicles.length > 0) {
      gasolineVehicles.forEach((gv) => {
        gv.images.forEach((image) => {
          if (image.legal_info_required === 1) {
            image.legal_info = gv.legal_info;
          }
        });
      });
    }
    return gasolineVehicles;
  };
  
  export default fetchGasolineVehicles;
